import {
  Camera, Search, Link as LinkIcon, Lightbulb, Users, Infinity as InfinityIcon, Inbox, Check, Send,
  Home, Plus, Grid3x3, MapPin, FileText, Mic, Video, File, Settings,
  Trash2, LogOut, Compass, Download, X, Tag, FolderOpen, Clock, CheckCircle2,
} from "lucide-react";

export const MODULE_ICONS = {
  camera: Camera, search: Search, link: LinkIcon, check: Check, send: Send,
  inbox: Inbox, home: Home, lightbulb: Lightbulb, users: Users,
  infinity: InfinityIcon, "plus-circle": Plus, grid: Grid3x3,
};

export {
  Camera, Search, LinkIcon, Lightbulb, Users, InfinityIcon, Home, Inbox, Plus,
  Grid3x3, MapPin, FileText, Mic, Video, File, Settings, Trash2, LogOut, Compass,
  Download, X, Tag, FolderOpen, Clock, Check, CheckCircle2, Send,
};
